import React from "react";

const Intercorrencias = () => {
  return <div>Intercorrencias</div>;
};

export default Intercorrencias;
